import { create } from "zustand";

const useStore = create((set) => ({
  matchTournamentId: "",
  loadingMatches: false,
  loadingMatch: false,
  loadingSeasons: false,
  loadingPost: false,
  mode: false,
  matches: [],
  matchId: "",
  openMobileMenu: false,
  regionSelected: "",
  competences: [],
  competenceSelected: "",
  seasons: [],
  seasonSelected: "",
  menuItems: {},
  matchesOpen: [],
  handleToggleLoadingMatches: () =>
    set((state) => ({
      loadingMatches: !state.loadingMatches,
    })),
  handleToggleLoadingSeasons: () =>
    set((state) => ({
      loadingSeasons: !state.loadingSeasons,
    })),
  handleToggleLoadingPost: () =>
    set((state) => ({
      loadingPost: !state.loadingPost,
    })),
  handleToggleLoadingMatch: () =>
    set((state) => ({
      loadingMatch: !state.loadingMatch,
    })),
  handleOptionChange: () =>
    set((state) => ({
      matches: [],
      matchId: "",
      competences: [],
      competenceSelected: "",
      seasons: [],
      seasonSelected: "",
      menuItems: {},
      mode: !state.mode,
      matchesOpen: [],
    })),
  setRegion: (idRegion) =>
    set(() => ({
      regionSelected: idRegion,
    })),
  setSeason: (idSeason) =>
    set(() => ({
      seasonSelected: idSeason,
    })),
  setSeasons: (seasonsArray) =>
    set(() => ({
      seasons: seasonsArray,
    })),
  setCompetence: (idCompetence) =>
    set((state) => ({
      matches: [],
      matchId: "",
      seasons: [],
      seasonSelected: "",
      competenceSelected: idCompetence,
      matchesOpen: [],
    })),
  setDataMatches: (data) =>
    set((state) => ({
      matches: data,
    })),
  setMatchId: (matchId) =>
    set((state) => ({
      matchId: matchId,
    })),
  handleMenuItems: (data) =>
    set((state) => {
      let regionsMenu = {};
      for (const region of data) {
        const { name = "" } = region;

        if (!regionsMenu.hasOwnProperty(name)) {
          regionsMenu[name] = { ...region };
        }
      }
      return {
        menuItems: regionsMenu,
      };
    }),
  handleGetCompetences: (data) =>
    set((state) => ({
      competences: data,
      competenceSelected: "",
    })),
  clearCompetence: () =>
    set((state) => {
      return {
        matches: [],
        matchId: "",
        competences: [],
        competenceSelected: "",
        seasons: [],
        seasonSelected: "",
        matchesOpen: [],
      };
    }),
  handleMobileMenu: (bool) =>
    set((state) => ({
      openMobileMenu: bool,
    })),
  handleAddMatchOpen: (data) =>
    set((state) => ({
      matchesOpen: data,
    })),
  handleRemoveMatchOpen: (data) =>
    set((state) => ({
      matchesOpen: state.matchesOpen.filter((e) => e === "data"),
    })),
}));
export default useStore;